import React from "react";
import Signature from "../assets/img/ian-signature.png";
import { Link } from "react-router-dom";

function MainContent() {
  return (
    <section className="MainContent">
      <h1 className="PageTitle" data-text="one day die">
        one day die
      </h1>

      <h2 className="sr-only">About the event</h2>
      {/* TODO: Uncomment when dates are sold out
      <div>
        <p>
          dying to know when new dates and times are announced? click below to
          stay informed.
        </p>
        <a className="btn" href="https://onedaydie.com">
          sign up, hear first
        </a>
      </div> */}
      <p>
        it is time we made a compact. a binding agreement between your side and
        mine.
      </p>
      <p>
        our services do not come cheap. the world we play in is dangerous and
        dark, but we will guide you… for a price. i will send you a box that
        holds powers you can not fully comprehend and in return you send us
        equity to prove your seriousness in traversing this exploration into the
        unknown.
      </p>
      <p>
        but, buyer beware. what we send is not a novelty or cheap gimmick. we do
        not peddle trinkets. each and every receptacle contains an apportionment
        of carefully curated apparatuses you will need to navigate the abnormal.
      </p>
      <p>
        we understand these times are complicated, and for many, riches are
        sparse; one box can entertain many. those who live together need
        purchase only one. if you do not live together we are not asking you to
        congregate. we forbid mingling of households. a word of caution,
        shipping times are outside of my regulation. those who wait to secure
        their participation risk the window closing. chop, chop.
      </p>
      <p>
        some of you, living on the other side of the pond, desperately wanting
        to tithe and procure your place must be patient. add your name to the
        list below. we’re trying our best. below you will find the dates we are
        currently offering our services. once your ticket is purchased and your
        box dispatched, we begin your assemblage process.
      </p>
      <p>
        the year is 2020. political unrest. pandemics. murder locusts and now,
        burning infernos destroying the western seaboard. we will do our best to
        ensure your ticketed showtime is met with no truancy, but… as stated
        earlier, it is 2020. if, for some reason, one of above tangles with this
        production, your ticket will be moved to a following week. we thank you
        greatly for understanding.
      </p>
      <p>
        one final statement, consider it a warning. do not open, or tamper with
        your box when it arrives. many of you pride yourself on your wit, and
        cleverness; heed this warning; however intelligent and sprightly you
        view yourself, you are not. we will know. if the parcel has been opened
        prior to our rendezvous, you will be banished from the proceeding
        ceremony. you are not simply buying a box, you are commencing our
        relationship of trust.
      </p>
      <p>
        this experience is not for the weak or fragile minded. you will be
        challenged and asked to participate. this is not a passive engagement.
        we require action. tickets are limited, proceed with haste.
      </p>
      <p className="text-right">
        <img
          className="MainContent__signature"
          src={Signature}
          alt="Ian Oddeye"
        />
      </p>

      <h2>Questions?</h2>
      <p>
        <Link className="btn" to="/faq">
          Frequently Asked Questions
        </Link>
      </p>
    </section>
  );
}

export default MainContent;
